
/* START_TEMPLATE */
define('hbs!app/templates/amount',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data,depths) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<label class=\"label-amount";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.other : depth0), {"name":"if","hash":{},"fn":this.program(2, data, depths),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.isLong : depth0), {"name":"if","hash":{},"fn":this.program(4, data, depths),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\" title=\"";
  stack1 = ((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"display","hash":{}}) : helper));
  if (stack1 != null) { buffer += stack1; }
  buffer += "\">\n        <input name=\"SelectAmount\" type=\"radio\" ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.other : depth0), {"name":"if","hash":{},"fn":this.program(6, data, depths),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  buffer += " value=\""
    + escapeExpression(((helper = (helper = helpers.val || (depth0 != null ? depth0.val : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"val","hash":{}}) : helper)))
    + "\">\n        ";
  stack1 = ((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"display","hash":{}}) : helper));
  if (stack1 != null) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.other : depth0), {"name":"if","hash":{},"fn":this.program(8, data, depths),"inverse":this.program(15, data, depths)});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</label>";
},"2":function(depth0,helpers,partials,data) {
  return " label-otheramount";
  },"4":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return " "
    + escapeExpression(((helper = (helper = helpers.isLong || (depth0 != null ? depth0.isLong : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"isLong","hash":{}}) : helper)));
},"6":function(depth0,helpers,partials,data) {
  return "class=\"radio-other\" ";
  },"8":function(depth0,helpers,partials,data,depths) {
  var stack1, buffer = "<input type=\"number\" tabindex=\"-1\" autocomplete=\"transaction-amount\" class=\"edit-otheramount\" name=\"OtherAmount\"\n            title=\"Other Amount\" ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.otherAmountPlaceholderOverride : depth0), {"name":"if","hash":{},"fn":this.program(9, data, depths),"inverse":this.program(11, data, depths)});
  if (stack1 != null) { buffer += stack1; }
  buffer += ">\n";
  stack1 = helpers['if'].call(depth0, (depths[2] != null ? depths[2].isUSD : depths[2]), {"name":"if","hash":{},"fn":this.program(13, data, depths),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"9":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return " placeholder=\""
    + escapeExpression(((helper = (helper = helpers.otherAmountPlaceholderOverride || (depth0 != null ? depth0.otherAmountPlaceholderOverride : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"otherAmountPlaceholderOverride","hash":{}}) : helper)))
    + "\"\n            ";
},"11":function(depth0,helpers,partials,data) {
  return " placeholder=\"0.00\" ";
  },"13":function(depth0,helpers,partials,data,depths) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression;
  return "          <span class=\"label-otheramount-prefix\">"
    + escapeExpression(lambda(((stack1 = (depths[3] != null ? depths[3].currency : depths[3])) != null ? stack1.symbol : stack1), depth0))
    + "</span>\n";
},"15":function(depth0,helpers,partials,data) {
  return "<a></a> ";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,depths) {
  var stack1, buffer = "<div class=\"at-row SelectAmount OtherAmount NonRecurringButtons\">\n  <div class=\"at-radio\">\n    <div class=\"at-radios clearfix\">\n";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.amount_options : depth0), {"name":"each","hash":{},"fn":this.program(1, data, depths),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "    </div>\n  </div>\n</div>";
},"useDepths":true});
Handlebars.registerPartial('app/templates/amount', t);
return t;
});
/* END_TEMPLATE */
;
